
export const shopMenu = {
    key: "shop-menu",
    init: (value) => {
        const shopMenu = document.querySelector("#decked-shop-menu");
        const shopMobileMenu = document.querySelector("#decked-shop-mobile-menu");
        const mainMenu = document.querySelector("#main-menu");
        const mainMobileMenu = document.querySelector("#decked-main-mobile-menu");

        if(value){
            shopMenu.classList.remove("hidden");
            shopMobileMenu.classList.remove("hidden");
            mainMenu.classList.add("hidden");
            mainMobileMenu.classList.add("hidden");
        }else{
            shopMenu.classList.add("hidden");
            shopMobileMenu.classList.add("hidden");
            mainMenu.classList.remove("hidden");
            mainMobileMenu.classList.remove("hidden");
        }
    }
}